import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Layout from 'components/Layout'

import { ChevronRight, Paperclip } from 'lucide-react'
import { initializeTemplates } from 'slices/templateSlice'

function SidebarDetailTemplatesAccordian() {
	const dispatch = useDispatch()

	const {
		entities: templateEntities,
		ids: templateIds,
		isInitialized: templatesInitialized,
	} = useSelector(state => state.templates)
	const newTemplates = templateIds.map(id => templateEntities[id])

	const taskTemplates = newTemplates.filter(item => item.templateType === 'task')
	const siteDetailTemplates = newTemplates.filter(item => item.templateType !== 'task')

	useEffect(() => {
		dispatch(initializeTemplates())
	}, [dispatch])

	return (
		<Layout.SidebarItem title="Site Details Templates" icon={<Paperclip className="w-4 h-4" />} hasNoMaxHeight>
			{templatesInitialized && (
				<React.Fragment>
					<div>
						{siteDetailTemplates.map(template => (
							<Link
								key={template._id}
								to={`/templates/${template._id}/${template.templateType}`}
								className="flex items-center px-4 py-2 hover:bg-gray-50 no-underline text-inherit"
							>
								<div className="flex-1 min-w-0">
									<div className="text-sm text-gray-900">{template.templateName}</div>
									<div className="text-xs text-gray-500">
										{template.description.length > 48
											? template.description.substring(0, 48) + '...'
											: template.description}
									</div>
								</div>
								<ChevronRight className="w-4 h-4 text-gray-400 shrink-0 ml-2" />
							</Link>
						))}
					</div>
				</React.Fragment>
			)}
		</Layout.SidebarItem>
	)
}

export default SidebarDetailTemplatesAccordian
